import React from 'react';
import { NavItemDef } from '../navItems';
import { getLmsUrl } from 'data_sources/constants';

export const TRAINING_NAV_ITEMS: NavItemDef[] = [
  /*{
    key: 'training.lmsAssignments',
    label: 'common.navItems.training.lmsAssignments',
    href: getLmsUrl('/assigned-learning/assignments'),
    newWindow: true,
    permissions: ['trainingAdminActions'],
  },*/
];
